import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import Grid from "@material-ui/core/Grid";
import styles from "./ChallengeDetailsSkeleton.module.scss";

const ChallengeDetailsSkeleton = () => {
  return (
    <div>
      <div className={styles.challengeDetailsSkeleton_row}>
        <Skeleton height={400} variant="rect" />
      </div>

      <Grid container direction="row" spacing={4}>
        <Grid item xs={12} md={8}>
          <Skeleton height={36} />

          <Skeleton height={72} width={200} />

          <Skeleton height={36} variant="rect" />

          <Skeleton height={36} />

          <Skeleton height={36} variant="rect" />

          <Skeleton height={36} />

          <Skeleton height={36} variant="rect" />

          <Skeleton height={36} />

          <Skeleton height={36} variant="rect" />

          <Skeleton height={36} />

          <Skeleton height={36} variant="rect" />
        </Grid>

        <Grid item xs={12} md={4}>
          <Skeleton height={300} variant="rect" />
        </Grid>
      </Grid>
    </div>
  );
};

export default ChallengeDetailsSkeleton;
